module.exports = __webpack_public_path__ + "img/hose.92ee1e54.png";